import { CommonMsgNodeProps, BtnMessageType } from '@/types/message'
import styles from './index.module.scss'
import Button from '@/components/ai-agent/btn'
import React from 'react'
import { Button as AntdButton, Modal, Image } from 'antd'
import classNames from 'classnames'
import { customApiCall } from '@/proxy-request/chat-completion'
import { saveActionRecordToServer } from '@/proxy-request/help'
import { safeParseJson } from '@/utils'
import useNodeSubmitDisabledStatus from '@/hooks/use-node-disabled'
import { observer } from 'mobx-react'

interface BtnMsgProps extends CommonMsgNodeProps {
  node: BtnMessageType
}

const BtnMsg = (props: BtnMsgProps) => {
  const { node } = props
  const { onlyClickOnce = false, key } = node.value || {}
  const type = node.value?.type || 'primary'

  const { submitDisabled, setSubmitDisabled } = useNodeSubmitDisabledStatus({
    messageId: props?.msgContent?.message_id || '',
    initialDisabled: false
  })

  const { value, display = 'block' } = node
  const isBlockLayout = display === 'block'
  const clickCountRef = React.useRef<number>(0)
  const [loading, setLoading] = React.useState(false)
  const extDataRef = React.useRef<any>({})

  React.useEffect(() => {
    const blockNode = props.msgContent.content?.[0]

    if (blockNode?.ext_data) {
      const ext_data = safeParseJson(blockNode.ext_data)
      if (ext_data) extDataRef.current = ext_data
    }

    //后端下发的模版下，组下面多个按钮只能点击一次
    if (node.value.key && node.value.onlyClickOnce && !!extDataRef.current) {
      Object.keys(extDataRef.current).forEach(key => {
        if (key.includes(`btn_click_count_`)) {
          setSubmitDisabled(true)
        }
      })
    }

    //单个按钮只能点击一次
    if (!node.value.key && node.value.onlyClickOnce) {
      if (extDataRef.current[`btn_click_count`]) {
        const clickCount = extDataRef.current[`btn_click_count`]
        if (clickCount >= 1) {
          setSubmitDisabled(true)
        }
      }
    }
  }, [])

  const onClick = async () => {
    const clickType = node?.value?.clickType
    const qrCodeModalTitle = node?.value?.qrCodeModalTitle || undefined
    const clickTypes = Array.isArray(clickType) ? clickType : [clickType]

    clickTypes?.forEach?.(async clickType => {
      if (clickType === 'qrCode') {
        Modal.info({
          title: qrCodeModalTitle,
          maskClosable: true,
          closeIcon: true,
          icon: null,
          okText: '确定',
          width: '60vw',
          className: styles.qcModalContainer,
          content: (
            <div className={styles.qcModal}>
              <Image src={node.value.qrCodeUrl} alt="二维码" />
            </div>
          )
        })
      }

      if (clickType === 'url') {
        window.open(node.value.url, '_blank')
      }

      if (node?.value?.intention && clickType === 'intention') {
        if (onlyClickOnce && clickCountRef.current >= 1) {
          setSubmitDisabled(true)
          return
        }
        if (onlyClickOnce) setSubmitDisabled(true)

        const params: any = {
          intention: node.value?.intention,
          text: `${node.value.intentionDesc}`
        }
        if (node.value?.params?.platform !== undefined && node.value?.params?.platform !== null) {
          params.platform = node.value.params.platform
        }
        setLoading(true)
        await props.chatCompletion({
          body: params
        })
        if (onlyClickOnce) {
          clickCountRef.current += 1
          saveActionRecordToServer({
            message_id: props.msgContent.message_id,
            value: {
              [key ? `btn_click_count_${key}` : 'btn_click_count']: clickCountRef.current
            },
            mergeRemoteData: true
          })
        }

        setLoading(false)
      }

      if (clickType === 'request' && node.value.requestUrl) {
        if (onlyClickOnce && clickCountRef.current >= 1) {
          setSubmitDisabled(true)
          return
        }
        if (onlyClickOnce) setSubmitDisabled(true)

        clickCountRef.current += 1
        setLoading(true)
        customApiCall({
          body: (node?.value?.params || {}) as any,
          customUrl: node.value.requestUrl,
          opt: {
            onConnect() {
              setLoading(false)
            }
          }
        })

        // if (onlyClickOnce) {
        //   saveActionRecordToServer({
        //     message_id: props.msgContent.message_id,
        //     value: {
        //       [key ? `btn_click_count_${key}` : 'btn_click_count']: clickCountRef.current
        //     },
        //     mergeRemoteData: true
        //   })
        // }
      }
    })
  }

  let style: React.CSSProperties = {
    display: isBlockLayout ? 'flex' : 'inline-flex',
    cursor: 'pointer'
  }

  if (isBlockLayout) {
    style = {
      ...style,
      marginTop: '7px'
    }
  }

  if (['text'].includes(type)) {
    return (
      <AntdButton
        style={style}
        type={type}
        disabled={submitDisabled}
        onClick={onClick}
        className="y-mx-3"
      >
        {value?.text}
      </AntdButton>
    )
  }

  return (
    <Button
      loading={loading}
      type={type}
      disabled={loading || submitDisabled}
      onClick={onClick}
      className={classNames(styles.btnContainer, 'y-mx-2')}
      style={style}
    >
      {value?.text}
    </Button>
  )
}

export default observer(BtnMsg)
